import React from "react";

export const PrimaryButton = ({ children, className = "", ...rest }) => (
  <button
    className={`w-full h-[56px] bg-[#8BA38E] hover:bg-[#7A917D] active:bg-[#6A7F6C] text-white font-semibold rounded-[20px] flex items-center justify-center transition-all duration-300 shadow-[0_4px_16px_rgba(139,163,142,0.3)] disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-[#8BA38E] ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export const GlassButton = ({ children, className = "", ...rest }) => (
  <button
    className={`w-full h-[56px] bg-white/50 hover:bg-white/60 backdrop-blur-md border border-white/40 text-[#2A3B32] font-semibold rounded-[20px] flex items-center justify-center transition-all duration-300 shadow-[0_4px_16px_rgba(0,0,0,0.04)] focus:outline-none focus:ring-2 focus:ring-[#8BA38E] ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export default PrimaryButton;
